{
  "unauthorizedRoute": {
    "subtitle": "Non sei autorizzato ad accedere a questa pagina",
    "title": "Non autorizzato"
  },
  "pageNotFound": "Pagina non trovata",
  "httpStatusCodes": {
    "400": {
      "title": "Errore Bad Request",
      "subtitle": "Si è verificato un errore Bad Request, controlla i tuoi dati e riprova.",
      "codes": {
        "INVALID_VALUE_NOT_NULL": "Il campo \"{field}\" è obbligatorio.",
        "JSON_NOT_VALID": "Il contenuto non è in un formato JSON valido.",
        "SCHEMA_NOT_MATCH": "Il contenuto non corrisponde al modello previsto.",
        "SCHEMA_NOT_MATCH_FIELD": "Il contenuto non corrisponde allo schema previsto, errore nella proprietà \"{field}\".",
        "CERTIFICATE_RENEWAL_FAILED_NO_DNS_MATCH": "Il DNS & CN non corrisponde alla configurazione del certificato."
      }
    },
    "409": {
      "title": "Errore di conflitto",
      "subtitle": "Si è verificato un errore di conflitto, controlla i tuoi dati e riprova.",
      "codes": {
        "UNICITY_CONSTRAINT": "Il valore del campo \"{field}\" è già utilizzato.",
        "UNICITY_CONSTRAINT_FIELD_LOGIN": "Il nome utente è già stato utilizzato.",
        "UNICITY_CONSTRAINT_FIELD_EMAIL": "L'e-mail è già stata utilizzata.",
        "UNICITY_CONSTRAINT_FIELD_NAME_ORGANIZATION": "Il nome dell'organizzazione è già stato utilizzato.",
        "UNICITY_CONSTRAINT_FIELD_USER_GROUP": "Esiste già un gruppo utente con questo nome.",
        "UNICITY_CONSTRAINT_FIELD_USER_PROFILE": "Esiste già un profilo con questo nome."
      }
    },
    "404": {
      "title": "Introvabile",
      "subtitle": "La risorsa non è disponibile o è stata eliminata."
    },
    "401": {
      "title": "Non connesso",
      "subtitle": "Non sei connesso."
    },
    "403": {
      "title": "Accesso non autorizzato",
      "subtitle": "Non hai le autorizzazioni necessarie.",
      "codes": {
        "SECTOR_DEPTH_EXCEEDED": "La profondità massima del settore non può essere superiore a {maximum_allowed_depth}.",
        "SECTOR_DELETE_FORBIDDEN": "Impossibile eliminare il settore perché vi sono alcuni apparati collegati."
      }
    },
    "500": {
      "title": "Si è verificato un errore",
      "subtitle": "Riprovare di nuovo."
    },
    "405": {
      "title": "Non consentito",
      "subtitle": "Non ti è consentito eseguire questa operazione."
    },
    "408": {
      "title": "Impossibile caricare la pagina",
      "subtitle": "La richiesta ha impiegato troppo tempo per rispondere."
    }
  },
  "download": {
    "noData": "Nessun dato da scaricare"
  }
}
